import React from 'react';
import { OrderCard } from './OrderCard';
import { OrdersPanelFilterRow } from './OrdersPanelFilterRow';

export function OrdersTrackingPanel({
  regionalBranch,
  loading,
  loadError,
  filteredCount,
  totalCount,
  listCount,
  mapCount,
  ordersWithoutMap,
  orders,
  selectedId,
  onSelectOrder,
  statusFilter,
  onStatusFilterChange,
  statusTabCounts,
  orderIdSearch,
  onOrderIdSearchChange,
}) {
  return (
    <aside className='otd-panel'>
      <div className='otd-panel__header'>
        <div className='otd-panel__title-wrap'>
          <h1 className='otd-panel__title'>Tracking Orders</h1>
        </div>
      </div>

      <OrdersPanelFilterRow
        statusFilter={statusFilter}
        onStatusFilterChange={onStatusFilterChange}
        statusTabCounts={statusTabCounts}
        orderIdSearch={orderIdSearch}
        onOrderIdSearchChange={onOrderIdSearchChange}
      />

      {loadError && <p className='otd-panel__error'>{loadError}</p>}

      <div className='otd-panel__list'>
        {loading && !orders.length ? (
          <p className='otd-panel__empty'>Loading orders…</p>
        ) : null}
        {!loading && !orders.length && filteredCount > 0 ? (
          <p className='otd-panel__empty'>
            {filteredCount} order(s) returned but could not be displayed. Check filters or date.
          </p>
        ) : null}
        {!loading && !orders.length && filteredCount === 0 ? (
          <p className='otd-panel__empty'>No orders match these filters.</p>
        ) : null}
        {!loading && ordersWithoutMap > 0 ? (
          <p className='otd-panel__empty otd-panel__empty--hint'>
            {ordersWithoutMap} order(s) have no map coordinates and appear in the list only.
          </p>
        ) : null}
        {orders.map((order) => (
          <OrderCard
            key={order.id}
            order={order}
            selected={selectedId === order.id}
            onSelect={onSelectOrder}
          />
        ))}
      </div>
    </aside>
  );
}
